import React, { useState } from 'react';
import { Table, Select, Input, Button, Typography, Form, message } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import '../../css/JuanIS/JuanISFacultyGrades.css';

const { Option } = Select;
const { Title } = Typography;

function JuanISFacultyGrades() {
  const [selectedClass, setSelectedClass] = useState('STEM-11A-OralComm');
  const [selectedQuarter, setSelectedQuarter] = useState('1');

  // Sample data - replace with actual data from your backend
  const classes = [
    { value: 'STEM-11A-OralComm', label: 'STEM-11A - Oral Communication' },
    { value: 'STEM-11B-GenMath', label: 'STEM-11B - General Mathematics' }
  ];

  const quarters = [
    { value: '1', label: '1st Quarter' },
    { value: '2', label: '2nd Quarter' },
    { value: '3', label: '3rd Quarter' },
    { value: '4', label: '4th Quarter' }
  ];

  const [studentGrades, setStudentGrades] = useState([
    {
      key: '1',
      studentId: '2024-0001',
      name: 'Juan Dela Cruz',
      writtenWork: '90',
      performanceTask: '88',
      quarterlyAssessment: '92',
      finalGrade: '90'
    },
    {
      key: '2',
      studentId: '2024-0002',
      name: 'Maria Santos',
      writtenWork: '85',
      performanceTask: '90',
      quarterlyAssessment: '88',
      finalGrade: '88'
    }
  ]);

  const handleGradeChange = (key, field, value) => {
    const newGrades = studentGrades.map(student => {
      if (student.key === key) {
        const newStudent = { ...student, [field]: value };
        // Calculate final grade
        if (['writtenWork', 'performanceTask', 'quarterlyAssessment'].includes(field)) {
          const ww = parseFloat(newStudent.writtenWork) * 0.3;
          const pt = parseFloat(newStudent.performanceTask) * 0.5;
          const qa = parseFloat(newStudent.quarterlyAssessment) * 0.2;
          newStudent.finalGrade = Math.round(ww + pt + qa).toString();
        }
        return newStudent;
      }
      return student;
    });
    setStudentGrades(newGrades);
  };

  const columns = [
    {
      title: 'Student ID',
      dataIndex: 'studentId',
      key: 'studentId',
      width: 120,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: 200,
    },
    {
      title: 'Written Work (30%)',
      dataIndex: 'writtenWork',
      key: 'writtenWork',
      width: 150,
      render: (text, record) => (
        <Input
          value={text}
          onChange={e => handleGradeChange(record.key, 'writtenWork', e.target.value)}
          className="juanis-faculty-grades-input"
        />
      ),
    },
    {
      title: 'Performance Task (50%)',
      dataIndex: 'performanceTask',
      key: 'performanceTask',
      width: 150,
      render: (text, record) => (
        <Input
          value={text}
          onChange={e => handleGradeChange(record.key, 'performanceTask', e.target.value)}
          className="juanis-faculty-grades-input"
        />
      ),
    },
    {
      title: 'Quarterly Assessment (20%)',
      dataIndex: 'quarterlyAssessment',
      key: 'quarterlyAssessment',
      width: 150,
      render: (text, record) => (
        <Input
          value={text}
          onChange={e => handleGradeChange(record.key, 'quarterlyAssessment', e.target.value)}
          className="juanis-faculty-grades-input"
        />
      ),
    },
    {
      title: 'Final Grade',
      dataIndex: 'finalGrade',
      key: 'finalGrade',
      width: 100,
    }
  ];

  const handleSave = () => {
    // Add API call to save grades
    message.success('Grades saved successfully');
  };

  return (
    <div className="juanis-faculty-grades-container">
      <div className="juanis-faculty-grades-header">
        <Title level={2}>Handling of Grades</Title>
        <div className="juanis-faculty-grades-header-controls">
          <Select
            value={selectedClass}
            onChange={setSelectedClass}
            className="juanis-faculty-grades-class-select"
          >
            {classes.map(cls => (
              <Option key={cls.value} value={cls.value}>{cls.label}</Option>
            ))}
          </Select>
          <Select
            value={selectedQuarter}
            onChange={setSelectedQuarter}
            className="juanis-faculty-grades-quarter-select"
          >
            {quarters.map(quarter => (
              <Option key={quarter.value} value={quarter.value}>{quarter.label}</Option>
            ))}
          </Select>
        </div>
      </div>

      <div className="juanis-faculty-grades-content">
        <Table 
          dataSource={studentGrades} 
          columns={columns}
          pagination={false}
          className="juanis-faculty-grades-table"
          scroll={{ x: 800 }}
        />
        
        <div className="juanis-faculty-grades-save-section">
          <Button 
            icon={<SaveOutlined />}
            onClick={handleSave}
            className="juanis-faculty-grades-save-button"
          >
            Save Grades
          </Button>
        </div>
      </div>
    </div>
  );
}

export default JuanISFacultyGrades;